// src/data/agents.js — IAvocat.ai Agent Team mapping
// Each agent groups one or more skills from the Skills Engine.

export const AGENT_CATEGORIES = {
  general: { label: 'Accueil', color: '#888780' },
  penal: { label: 'Pénal', color: '#534AB7' },
  civil: { label: 'Civil', color: '#378ADD' },
  famille: { label: 'Famille', color: '#D4537E' },
  corporel: { label: 'Corporel', color: '#D85A30' },
  secretariat: { label: 'Secrétariat', color: '#1D9E75' },
  immobilier: { label: 'Immobilier', color: '#639922' },
  pi: { label: 'PI & Conso', color: '#BA7517' },
  administratif: { label: 'Administratif', color: '#888780' },
  travail: { label: 'Travail', color: '#993C1D' },
  affaires: { label: 'Affaires', color: '#378ADD' },
  'procedures-collectives': { label: 'Proc. collectives', color: '#0F6E56' },
  fiscal: { label: 'Fiscal', color: '#854F0B' },
  rgpd: { label: 'RGPD', color: '#185FA5' },
  environnement: { label: 'Environnement', color: '#3B6D11' },
  successions: { label: 'Successions', color: '#534AB7' },
  transversal: { label: 'Transversal', color: '#1D9E75' },
};

export const AGENTS = [
  // ── Secrétariat ──
  {
    id: 'sophie',
    name: 'Sophie',
    title: 'Secrétaire juridique',
    gender: 'F',
    category: 'secretariat',
    skills: ['secretaire-emails', 'secretaire-agenda', 'secretaire-courriers', 'secretaire-cabinet'],
    primarySkill: 'secretaire-emails',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/sophie.jpg',
    bio: "Je gère vos emails, votre agenda, vos courriers et l'administration générale du cabinet au quotidien.",
  },

  // ── Points d'entrée ──
  {
    id: 'emilie',
    name: 'Émilie',
    title: 'Accueil & orientation',
    gender: 'F',
    category: 'general',
    skills: ['general-chat'],
    primarySkill: 'general-chat',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/emilie.jpg',
    bio: "Je suis votre premier point de contact. Je réponds à vos questions juridiques rapides, je vous oriente vers le bon collaborateur quand le sujet le nécessite, et je vous aide à formuler vos demandes complexes. N'hésitez pas à me solliciter pour toute question, même brève.",
  },
  {
    id: 'nicolas',
    name: 'Nicolas',
    title: 'Dossiers complexes multi-matières',
    gender: 'M',
    category: 'transversal',
    skills: ['specialiste-consolidation'],
    primarySkill: 'specialiste-consolidation',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/nicolas.jpg',
    bio: "Je suis votre référent pour les dossiers qui dépassent une seule matière. Affaires pénales avec volet civil, dossiers de famille avec enjeux patrimoniaux, contentieux mêlant plusieurs branches du droit — je coordonne les analyses des collaborateurs concernés et produis un livrable unifié et cohérent. Confiez-moi vos dossiers les plus complexes.",
  },

  // ── Pôle pénal ──
  {
    id: 'francoise',
    name: 'Françoise',
    title: 'Pénaliste senior',
    gender: 'F',
    category: 'penal',
    skills: ['collab-penal', 'synthese-penale', 'specialiste-nullites', 'specialiste-execution-penale'],
    primarySkill: 'collab-penal',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/francoise.jpg',
    bio: "Spécialiste en droit pénal, j'analyse vos dossiers, détecte les nullités de procédure, rédige conclusions, mémoires et synthèses de défense. Je vous accompagne aussi après la condamnation : aménagement de peine, libération conditionnelle, requêtes au juge d'application des peines, droit pénitentiaire.",
  },
  {
    id: 'guillaume',
    name: 'Guillaume',
    title: 'Pénal international & documents étrangers',
    gender: 'M',
    category: 'penal',
    skills: ['specialiste-mae', 'specialiste-traduction'],
    primarySkill: 'specialiste-mae',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/guillaume.jpg',
    bio: "Mandat d'arrêt européen, extradition, entraide pénale internationale — je gère vos dossiers pénaux à dimension transfrontalière. Je traite également les documents étrangers en français, anglais, espagnol, arabe et allemand pour vos affaires impliquant des clients ou des juridictions hors de France.",
  },

  // ── Contentieux civil & corporel ──
  {
    id: 'claire',
    name: 'Claire',
    title: 'Civiliste',
    gender: 'F',
    category: 'civil',
    skills: ['collab-civil', 'specialiste-execution-civile'],
    primarySkill: 'collab-civil',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/claire.jpg',
    bio: "Du référé à l'exécution forcée, je rédige assignations, conclusions et mises en demeure, et pilote le recouvrement de vos créances.",
  },
  {
    id: 'louise',
    name: 'Louise',
    title: 'Préjudice corporel & responsabilité médicale',
    gender: 'F',
    category: 'corporel',
    skills: ['collab-corporel', 'specialiste-victimes', 'specialiste-resp-medicale'],
    primarySkill: 'collab-corporel',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/louise.jpg',
    bio: "Experte en indemnisation, j'évalue vos dossiers selon la nomenclature Dintilhac, prépare les expertises et saisis la CIVI. Je traite aussi les dossiers de responsabilité médicale : infections nosocomiales, erreurs de diagnostic, aléas thérapeutiques, saisine de la CCI et recours devant les juridictions civiles et administratives.",
  },

  // ── Personnes & patrimoine familial ──
  {
    id: 'margaux',
    name: 'Margaux',
    title: 'Famille & droit international privé familial',
    gender: 'F',
    category: 'famille',
    skills: ['collab-famille', 'specialiste-famille-internationale'],
    primarySkill: 'collab-famille',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/margaux.jpg',
    bio: "Divorce, pension alimentaire, résidence des enfants, ordonnance de protection, autorité parentale — je rédige tous vos actes devant le JAF. Je traite également les dossiers familiaux internationaux : divorces transfrontaliers (Rome III, Bruxelles II ter), enlèvements internationaux d'enfants (Convention de La Haye 1980), successions internationales, régimes matrimoniaux internationaux, reconnaissance des décisions étrangères.",
  },
  {
    id: 'pierre',
    name: 'Pierre',
    title: 'Successions',
    gender: 'M',
    category: 'successions',
    skills: ['collab-successions'],
    primarySkill: 'collab-successions',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/pierre.jpg',
    bio: "Partage, testament, réduction, recel successoral — je vous accompagne dans les dossiers de succession les plus complexes.",
  },

  // ── Droit social ──
  {
    id: 'antoine',
    name: 'Antoine',
    title: 'Travail & sécurité sociale',
    gender: 'M',
    category: 'travail',
    skills: ['collab-travail', 'specialiste-secu-sociale'],
    primarySkill: 'collab-travail',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/antoine.jpg',
    bio: "Licenciement, harcèlement, prise d'acte, procédure prud'homale — je rédige toutes vos écritures devant le CPH. Je traite aussi les contentieux de sécurité sociale : accidents du travail, maladies professionnelles, faute inexcusable, contentieux CPAM et recours devant le pôle social du tribunal judiciaire.",
  },

  // ── Droit des affaires ──
  {
    id: 'thomas',
    name: 'Thomas',
    title: 'Contrats & Sociétés',
    gender: 'M',
    category: 'affaires',
    skills: ['collab-contrats', 'collab-societes'],
    primarySkill: 'collab-contrats',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/thomas.jpg',
    bio: "Statuts, pactes d'actionnaires, baux commerciaux, CGV, AG, cessions de parts — le droit des affaires est mon terrain.",
  },
  {
    id: 'camille',
    name: 'Camille',
    title: 'PI & Consommation',
    gender: 'F',
    category: 'pi',
    skills: ['collab-pi', 'collab-conso'],
    primarySkill: 'collab-pi',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/camille.jpg',
    bio: "Propriété intellectuelle et droit de la consommation : marques, brevets, droits d'auteur, clauses abusives et pratiques trompeuses.",
  },

  // ── Patrimoine immobilier ──
  {
    id: 'nadia',
    name: 'Nadia',
    title: 'Droit immobilier',
    gender: 'F',
    category: 'immobilier',
    skills: ['collab-immobilier'],
    primarySkill: 'collab-immobilier',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/nadia.jpg',
    bio: "Baux, expulsions, copropriété, construction, vices cachés — je rédige tous vos actes en droit immobilier.",
  },

  // ── Droit public ──
  {
    id: 'helene',
    name: 'Hélène',
    title: 'Droit administratif',
    gender: 'F',
    category: 'administratif',
    skills: ['collab-admin'],
    primarySkill: 'collab-admin',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/helene.jpg',
    bio: "Recours devant le tribunal administratif, REP, référés, droit des étrangers, OQTF et demandes d'asile.",
  },

  // ── Environnement & énergie ──
  {
    id: 'sarah',
    name: 'Sarah',
    title: 'Environnement, énergie & ICPE',
    gender: 'F',
    category: 'environnement',
    skills: ['collab-environnement'],
    primarySkill: 'collab-environnement',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/sarah.jpg',
    bio: "ICPE, études d'impact, loi sur l'eau, déchets, sites et sols pollués, énergies renouvelables, contentieux climat, préjudice écologique, devoir de vigilance, contrats CPPA — j'accompagne vos clients sur les enjeux environnementaux et de transition énergétique, devant les autorités administratives et le tribunal administratif.",
  },

  // ── Procédures collectives ──
  {
    id: 'mathilde',
    name: 'Mathieu',
    title: 'Procédures collectives',
    gender: 'M',
    category: 'procedures-collectives',
    skills: ['collab-procedures-collectives'],
    primarySkill: 'collab-procedures-collectives',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/mathilde.jpg',
    bio: "Sauvegarde, redressement, liquidation judiciaire — je rédige vos déclarations de créances, contestations de plans, requêtes en relevé de forclusion et accompagne vos clients dirigeants ou créanciers tout au long de la procédure collective.",
  },

  // ── Droit fiscal ──
  {
    id: 'alexandre',
    name: 'Alexandre',
    title: 'Droit fiscal',
    gender: 'M',
    category: 'fiscal',
    skills: ['collab-fiscal'],
    primarySkill: 'collab-fiscal',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/alexandre.jpg',
    bio: "Contrôle fiscal, redressement, contentieux devant le tribunal administratif ou judiciaire — j'analyse vos dossiers fiscaux, rédige réclamations, mémoires et transactions avec l'administration fiscale. ISF/IFI, plus-values, TVA, impôt sur les sociétés.",
  },

  // ── RGPD & données personnelles ──
  {
    id: 'lea',
    name: 'Léo',
    title: 'RGPD & données personnelles',
    gender: 'M',
    category: 'rgpd',
    skills: ['collab-rgpd'],
    primarySkill: 'collab-rgpd',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/lea.jpg',
    bio: "Mise en conformité RGPD, registre des traitements, AIPD, notifications de violation, contentieux devant la CNIL et les juridictions — je vous accompagne sur tous les aspects de la protection des données personnelles.",
  },

  // ── Support transversal ──
  {
    id: 'marc',
    name: 'Marc',
    title: 'Négociation & Expertise',
    gender: 'M',
    category: 'transversal',
    skills: ['specialiste-negociation', 'specialiste-expertise'],
    primarySkill: 'specialiste-negociation',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/marc.jpg',
    bio: "Préparation de transactions amiables et suivi d'expertises judiciaires : dires, notes techniques, contestations.",
  },
  {
    id: 'julien',
    name: 'Julien',
    title: 'Calculs & Facturation',
    gender: 'M',
    category: 'transversal',
    skills: ['specialiste-calculs', 'specialiste-facturation'],
    primarySkill: 'specialiste-calculs',
    photoUrl: 'https://mhixfakpafenionfrpto.supabase.co/storage/v1/object/public/agent-photos/julien.jpg',
    bio: "Calculs de délais, intérêts, barèmes, prescriptions, et gestion complète de la facturation : honoraires, CARPA, AJ.",
  },
];
